import { render, staticRenderFns } from "./srvLangSwitch.vue?vue&type=template&id=820eb680&"
import script from "./srvLangSwitch.vue?vue&type=script&lang=js&"
export * from "./srvLangSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports